import './ui/styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
const uiRoot = document.querySelector<HTMLElement>('#ui-root');

if (!canvas || !uiRoot) {
  throw new Error('Missing #game-canvas or #ui-root');
}

const game = new Game(canvas, uiRoot);

// Debug / QA hook
(window as unknown as { __stardrop?: Game }).__stardrop = game;

game.init().catch((err) => {
  console.error('Failed to start Stardrop:', err);
  uiRoot.innerHTML = `<div class="overlay visible"><div class="panel"><h2>Failed to load</h2><p>${String(err)}</p></div></div>`;
});

// HMR / debug
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    game.dispose();
  });
}
